module.exports = __webpack_public_path__ + "static/AvenirNext-Medium-ec3ee2aec4b967a04e746f5f31381cf4.woff";